import React from 'react';
import PolicyPage from '../../components/PolicyPage';

const CodeOfConduct: React.FC = () => (
  <PolicyPage slug="code-of-conduct" subtitle="Code of Conduct" />
);

export default CodeOfConduct;
